export function acronymize(toConvert: string): string {
  const arrayOfWords = toConvert.split(' ');
  if (arrayOfWords.length === 1) {
    return arrayOfWords[0].substring(0, 3);
  }
  return arrayOfWords.map((word) => word.charAt(0)).join('');
}
